var Category = /* @__PURE__ */ ((Category2) => {
  Category2["ContactLenses"] = "Contact-Lenses";
  Category2["Sunglasses"] = "Sunglasses";
  Category2["Optical"] = "Optical";
  Category2["Accessories"] = "Accessories";
  Category2["Solutions"] = "Solutions";
  Category2["ReadyReaders"] = "Ready-readers";
  return Category2;
})(Category || {});
var LineItemType = /* @__PURE__ */ ((LineItemType2) => {
  LineItemType2["Single"] = "single";
  LineItemType2["Subscription"] = "subscription";
  LineItemType2["Bundle"] = "bundle";
  return LineItemType2;
})(LineItemType || {});
var PurchaseType = /* @__PURE__ */ ((PurchaseType2) => {
  PurchaseType2["OneTime"] = "one-time";
  PurchaseType2["Subscription"] = "subscription";
  return PurchaseType2;
})(PurchaseType || {});
var BrandType = /* @__PURE__ */ ((BrandType2) => {
  BrandType2["OwnBrand"] = "own brand";
  BrandType2["ExternalBrand"] = "external brand";
  return BrandType2;
})(BrandType || {});
var Stock = /* @__PURE__ */ ((Stock2) => {
  Stock2["InStock"] = "in stock";
  Stock2["OutOfStock"] = "out of stock";
  return Stock2;
})(Stock || {});
var GlassLensPrescriptionType = /* @__PURE__ */ ((GlassLensPrescriptionType2) => {
  GlassLensPrescriptionType2["Prescription"] = "prescription lenses";
  GlassLensPrescriptionType2["NonPrescription"] = "non-prescription lenses";
  return GlassLensPrescriptionType2;
})(GlassLensPrescriptionType || {});
var EventType = /* @__PURE__ */ ((EventType2) => {
  EventType2["add"] = "add";
  EventType2["remove"] = "remove";
  EventType2["checkout"] = "checkout";
  EventType2["purchase"] = "purchase";
  return EventType2;
})(EventType || {});
export {
  BrandType,
  Category,
  EventType,
  GlassLensPrescriptionType,
  LineItemType,
  PurchaseType,
  Stock
};
//# sourceMappingURL=types.js.map
